<script setup>
import { useWebStore } from "~/store/web";
import { useRouter } from 'vue-router';
import EnquiryButton from "@/components/EnquiryButton.vue";
import ImageLazy from "./ImageLazy.vue";

const props = defineProps(['id', 'name', 'image', 'detailed', 'details', 'values', 'overlay', 'overlaytext', 'text', 'productPage', 'enquiryText']);

const store = useWebStore();
const router = useRouter();

const getRouteUrl = (routeName, idOfProd) => {
  return router.resolve({ path: `${routeName}/${idOfProd}`}).href;
};

const handleClick = (event) => {
  if (!props.productPage) {
    event.preventDefault();
    // Perform alternative action instead of navigating
    //console.log('Alternative action performed');
  }
  // Default anchor behavior (opening in the new tab) will happen automatically
  // if productPage is true and the default is not prevented
};
</script>
<template>
  <div>
    <a
      :href="productPage ? getRouteUrl(store.sites[4].url, id) : undefined"
      :target="productPage ? '_blank' : undefined"
      @click="handleClick"
      rel="noopener noreferrer"
      class="no-decoration blackText h100P grid"
    >
      <div class="product flex flex-col justify-between bg-gray-100 shadow-lg p-4 min-h-[300px] relative">
        <div class="flex flex-col flex-1">
          <div v-if="overlay" class="orange-overlay">
            <p class="text whiteText p15 h70per ofHide InterMedium">{{ overlaytext }}</p>
          </div>
          <ImageLazy :src="`/products/${image}`" class="w-11/12 mx-auto" alt="product picture" />
          <h4 class="SpaceGrotesk font-bold sm:text-left pt-3 text-xl lg:text-2xl">{{ name }}</h4>
          <!-- DETAILED CARD -->
          <div v-if="detailed" class="grid gap-4 grid-cols-1 pt-5">
            <div v-for="detail,index in details" :key="detail" class="w-full grid grid-cols-3 gap-4 border-b border-gray-200 lg:mr-5">
              <h5
                class="hMin whitespace-nowrap m-0 text-left col-span-2 lg:text-lg lg:whitespace-normal"
              >
                {{ detail }}
              </h5>
              <h5
                class="hMin whitespace-nowrap m-0 text-left lg:text-lg lg:whitespace-normal"
              >
                {{ values[index] }}
              </h5>
            </div>
          </div>
          <!-- CARD WITH TEXT -->
          <div v-if="text !== undefined" class="pt-4">
            <p class="hidden sm:block text-left text-sm lg:text-lg">{{ text }}</p>
          </div>
        </div>
        <div class="pt-4 mt-auto">
          <EnquiryButton
            class="w-3/4 no-wrap p-1 mt-auto"
            btnClass=""
            textClass="text-xs lg:text-lg xl:text-xl"
            :text="enquiryText === undefined ? store.locale.current.re1 : enquiryText"
            @click="$emit('enquiryClicked')"
          />
        </div>
      </div>
    </a>
  </div>
</template>



<style scoped lang="scss">
  .product{
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072),
    0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12);

    background-color: #F9F9F9;
    transition: ease 800ms;
  }
</style>